import { StyleSheet } from 'react-native'

export const ConfettiStyles = StyleSheet.create({
	video:{
		flex: 1,
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		top: 0,
		//width: '100%',
		//height: '100%',
		justifyContent: 'center',
		alignSelf: 'center',
		alignContent: 'center',
	}
});
